import React, { useState, useEffect, useRef } from 'react';
import { BASE_URL_OPENFORGE, IMAGE_PATH } from './Constants';
import { Link } from 'react-router-dom';
import { getInitials } from './Helper';
import { useLocation } from "react-router-dom";
import { useUser } from '../ContextApi/UserContext';
import { CLIENT_SECRET } from './Constants';
import { CLIENT_ID } from './Constants';
import { encryptAES } from './CryptoUtils';
import { BASE_URL_API } from './Constants';
import { DATA_DECRYPTION_KEY } from './Constants';
import axios from 'axios';
import { decryptAES } from './CryptoUtils';
import crypto from 'crypto-js';
import { IMAGE_PATH_Leader } from './Constants';
import { DEFAULT_USER_IMAGE } from './Constants';

export const Header = () => {

    const { user, isLoggedIn, handleLogout, checkLoginStatus } = useUser();
    const [searchQuery, setSearchQuery] = useState('');
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [profileUrl, setProfileUrl] = useState('');
    const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);

    const dropdownRef = useRef(null); // Reference for the dropdown
    
    const location = useLocation();
  // Function to toggle dropdown visibility
    const toggleDropdown = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    const handleOutsideClickOrEsc = (event) => {
      if (event.type === 'keydown' && event.key === 'Escape') {
        setDropdownVisible(false); // Close on Escape key press
      } else if (
        dropdownRef.current && 
        !dropdownRef.current.contains(event.target) // Click is outside dropdown
      ) {
        setDropdownVisible(false);
      }
    };
  
    // Use effect to add and clean up event listeners
    useEffect(() => {
      if (isDropdownVisible) {
        // Add event listeners when the dropdown is open
        document.addEventListener('click', handleOutsideClickOrEsc);
        document.addEventListener('keydown', handleOutsideClickOrEsc);
      } else {
        // Remove event listeners when the dropdown is closed
        document.removeEventListener('click', handleOutsideClickOrEsc);
        document.removeEventListener('keydown', handleOutsideClickOrEsc);
      }
  
      return () => {
        // Clean up event listeners on component unmount
        document.removeEventListener('click', handleOutsideClickOrEsc);
        document.removeEventListener('keydown', handleOutsideClickOrEsc);
      };
    }, [isDropdownVisible]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
        handleSearch();
        }
    };

    const fetchUserProfileImage = async () => {
      try {
            if (!user || !user.id) return;

            const fd = new FormData();
            fd.append("user_id", user.id);
            const ts = Math.floor(Date.now() / 1000);
            const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id.toString() + ts.toString();
            const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
            fd.append("client_id", CLIENT_ID);
            fd.append("ts", ts);
            fd.append("hmac", hmacHash);
            const jsonObject = {};
            fd.forEach((value, key) => {
                jsonObject[key] = value;
            });
                        
            const jsonString = JSON.stringify(jsonObject);
                        
            const encrypted = await encryptAES(jsonString, DATA_DECRYPTION_KEY);

            const secureFD = new FormData();
            secureFD.append("request_data", encrypted);     

            const response = await axios.post(
                `${BASE_URL_API}get_user_additional_profile`,
                secureFD
            );
            const decryptedText = await decryptAES(
                response.data.data,
                DATA_DECRYPTION_KEY
            );


            const profileArray = await JSON.parse(decryptedText);
            const profile =
                Array.isArray(profileArray) && profileArray.length > 0
                    ? profileArray[0]
                    : {};

            let imageUrl = "";

            if (profile?.profile_image) {
                imageUrl = `${IMAGE_PATH_Leader}/profile_images/${profile.profile_image.split("/").pop()}`;
                setProfileUrl(imageUrl);

            }
            else{
                setProfileUrl(DEFAULT_USER_IMAGE)
            }
      } catch (error) {
      console.error("Failed to fetch profile image:", error);
      setProfileUrl(null);
        
      }
    }

    useEffect(() => {
        setIsOffcanvasOpen(false);
    }, [location.pathname]);

    const closeOffcanvas = () => {
      if (window.innerWidth < 992) {
        setIsOffcanvasOpen(false);
      }
    };

    useEffect(()=>{
      if (user && user.id) {
        fetchUserProfileImage();
      }
    },[user])

    const handleLoginUrl = () => {
      const redirectUrl = location?.pathname ? location.pathname : '/collabwithgov';
        if(redirectUrl){
          localStorage.setItem("redirectUrl", redirectUrl);
        }
        // const redirectUrlGet = localStorage.getItem("redirectUrl");
        // const url = `${BASE_URL_OPENFORGE}${redirectUrlGet}`;
        
        window.location.href = `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
    };

    const handleRegisterUrl = () => {
        window.location.href = `${BASE_URL_OPENFORGE}/account/register.php`;
    };

    const handleSearch = () => {
        if (searchQuery.trim()) {
          const urll = `${BASE_URL_OPENFORGE}/search/?type_of_search=soft&number_of_page_results=15&exact=0&words=${encodeURIComponent(searchQuery)}`;
          // Redirect to the search URL
          window.location.href = urll;
        }
      };

    useEffect(() => {
      checkLoginStatus();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <>
        <style>{`
        @media (max-width: 992px) {
          .navbar-nav .nav-link.active, .navbar-nav .show > .nav-link, .nav-link, .navbar-nav .nav-link.active:hover, .navbar-nav .show > .nav-link:hover, .nav-link:hover {
            color:white !important;
        }
        .dropdown-menu {
          background: rgba(0, 103, 91, 1) !important;
        }
        .dropdown-item {
          color: #ffffff !important;
        }
      /* Fix dropdown icon alignment */
        .dropdown-toggle {
          display: flex;
          align-items: center;
        }
        .offcanvas .btn-close {
          filter: invert(1);   /* makes it white */
          opacity: 1;
        }

        .dropdown-toggle::after {
          margin-left: 6px;
          vertical-align: middle;
        }
        .navbar-nav li:nth-child(6){
          margin-top:0px !important;
          margin-bottom:0px !important;
        }
        #nav_login {
        min-width:350px;
        }
        #nav_user {
        min-width:350px;
        border: 1px solid #ffffff !important; 
        margin-top:10px;
        }    
        }`}
      </style>
           <nav className="navbar navbar-expand-lg fixed-top" id="navbar">
           {/* <div className="container-fluid">
                    <a className="navbar-brand" href={BASE_URL_OPENFORGE}><img src={`${IMAGE_PATH}/Government.png`} alt="Government.png"/> <img src={`${IMAGE_PATH}/organization_logo.png`} alt="organization_logo.png" style={{ width: '155px', height: '40px' }}/></a> */}
                <div className="container-fluid" style={{ height: '60px', padding: '10px' }}>
                    <a className="navbar-brand" href={BASE_URL_OPENFORGE}><img src={`${IMAGE_PATH}/nationalemblemindia.svg`} alt="nationalemblemindia.svg" style={{  height: '45px' }}/> <img src={`${IMAGE_PATH}/organization_logo.svg`} alt="organization_logo.svg" style={{ width: '155px', height: '45px' }}/></a>
                    <button className="navbar-toggler" type="button"   onClick={() => setIsOffcanvasOpen(true)} aria-label="Toggle navigation">
                        <img src={`${IMAGE_PATH}/menu_list.png`} alt="menu_list.png"/>
                    </button>
                  
                    <div
                      className={`offcanvas offcanvas-end ${isOffcanvasOpen ? 'show' : ''}`}
                      style={{ visibility: isOffcanvasOpen ? 'visible' : 'hidden' , zIndex:1, backgroundColor:'rgba(0, 103, 91, 1)'}}
                      >
                        <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasNavbarLabel"   style={{color:'white'}}>Government of India</h5>
                        <button type="button" className="btn-close text-reset" onClick={() => setIsOffcanvasOpen(false)}></button>
                        </div>
                        <div className="offcanvas-body">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                {/* <a href={`${BASE_URL_OPENFORGE}/softwaremap/trove_list.php`}className="nav-link active">Projects</a> */}
                                <Link 
                                to="/collabwithgov/publicprojects/" 
                                className="nav-link active" 
                                onClick={closeOffcanvas} 
                                >
                                Projects
                                </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/collabwithgov" className="nav-link active"   onClick={closeOffcanvas}>Collaborate</Link>
                                  </li>
                                <li className="nav-item">
                                  <Link to="/reusablerepo/" className="nav-link active"   onClick={closeOffcanvas}>Reusable Code</Link>
                                </li>
                                <li className="nav-item hide-on-md-down" style={{whiteSpace: 'nowrap'}}>
                                <a href="https://smartnet.niua.org/smartcode/" className="nav-link">Smart Code</a>
                                </li>
                                <li className="nav-item hide-on-md-down" style={{whiteSpace: 'nowrap'}}>
                                <a href={`${BASE_URL_OPENFORGE}/openforge/opengovernance.php`}className="nav-link">Open Governance</a>
                                </li>
                                <li className="nav-item dropdown">
                                    <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Help</button>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href={`${BASE_URL_OPENFORGE}/help`}>Get Help</a></li>
                                            <li><a className="dropdown-item" href={`${BASE_URL_OPENFORGE}/help/resources.php`}>Resources</a></li>
                                            <li><a className="dropdown-item" href={`${BASE_URL_OPENFORGE}/contact.php`}>Contact Us</a></li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Community</button>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href={`${BASE_URL_OPENFORGE}/community/contribute.php`}>Contribute</a></li>
                                        <li><Link className="dropdown-item" to="/collabwithgov"   onClick={closeOffcanvas}>Collaborate</Link></li>
                                        <li><Link className="dropdown-item" to="/reusablerepo/"   onClick={closeOffcanvas}>Reusable Code</Link></li>
                                    </ul>
                                </li>
                           
                            </ul>
                            <ul className="navbar-nav ms-auto">
                                {/* <li className="nav-item"> */}
                                        {/* <div className="input-group mb-3" id="header_search">
                                        <img src={`${IMAGE_PATH}/header_search.png`} alt="header_search.png"/>
                                            <input 
                                            type="search" 
                                            className="form-control rounded-pill" 
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                            />  
                                        </div> */}
                                {/* </li> */}
                                {((isLoggedIn) && (user)) ? (
                                    <div ref={dropdownRef}>
                                    {/* Button to open or close the dropdown */}
                                    <button 
                                      id="nav-dropdown-user" 
                                      className="border-0 tlp-profile tlp-button-secondary tlp-button-outline" 
                                      onClick={toggleDropdown} // Toggling dropdown visibility on button click
                                      title="Open user dropdown"
                                    >
                                      {/* previous code */}
                                      {/* {
                                        user.hasOwnProperty('profile_image')
                                        ?
                                        <img 
                                        src={user ? user.profile_image : ''} 
                                        alt="user avatar"
                                        />
                                        :
                                        <span className="user_avatar">{user ? getInitials(user.realname) : ''}</span>
                                      } */}
                                      {/* newcode */}
                                       {
                                       profileUrl
                                        ?
                                        <img 
                                        src={profileUrl} 
                                        alt="user avatar"
                                        />
                                        :
                                        <span className="user_avatar">{user ? getInitials(user.realname) : ''}</span>
                                      }
                                      
                                    </button>
                              
                                    {/* Dropdown content */}
                                    {isDropdownVisible && (
                                      <div 
                                        id="nav-dropdown-user-content" 
                                        className="tlp-popover nav-dropdown tlp-popover-shown" 
                                        data-popover-trigger="click" 
                                        data-popover-placement="bottom-end"
                                      >
                                        <div className="tlp-popover-arrow" style={{top: '-7px', transform: 'rotate(6deg)', right: '10px' }}></div>
                                        <div className="tlp-popover-header">
                                          <div className="tlp-avatar" aria-hidden="true">
                                            {/* previous code */}
                                          {/* {
                                            user.hasOwnProperty('profile_image')
                                            ?
                                            <img 
                                            src={user ? user.profile_image : ''} 
                                            alt="user avatar"
                                            />
                                            :
                                            <span className="user_avatar">{user ? getInitials(user.realname) : ''}</span>
                                          } */}
                                          {/* new code */}
                                          {
                                       profileUrl
                                        ?
                                        <img 
                                        src={profileUrl} 
                                        alt="user avatar"
                                        />
                                        :
                                        <span className="user_avatar">{user ? getInitials(user.realname) : ''}</span>
                                      }
                                          </div>
                                          <div className="nav-dropdown-user-names">
                                            <span className="name">{user ? user.realname : ''}</span>
                                            <span className="username">{user ? user.username : ''}</span>
                                          </div>
                                        </div>
                                        <div className="tlp-popover-body">
                                        <div>
                                            <a 
                                              href={`${BASE_URL_OPENFORGE}/users/${user ? user.username : ''}`} 
                                              className="tlp-dropdown-menu-item nav-dropdown-item nav-dropdown-item-unique-dashboard"
                                            >
                                              My Profile
                                            </a>
                                          </div>
                              
                                    
                                          <div>
                                            <a 
                                              href={`${BASE_URL_OPENFORGE}/my/`} 
                                              className="tlp-dropdown-menu-item nav-dropdown-item nav-dropdown-item-unique-dashboard"
                                            >
                                              My Dashboard
                                            </a>
                                          </div>
                              
                                          <hr className="tlp-dropdown-menu-separator" />
                              
                                          <a href={`${BASE_URL_OPENFORGE}/account/information`} className="tlp-dropdown-menu-item nav-dropdown-item">
                                            <i className="fa fa-fw fa-cog tlp-dropdown-menu-item-icon"></i>
                                            Preferences
                                          </a>

                                          
                                          <div className="pro_log1">
                                            <button className="tlp-dropdown-menu-item nav-dropdown-item" type="submit" title="Logout" onClick={handleLogout}>
                                              <i className="fa fa-fw fa-power-off tlp-dropdown-menu-item-icon"></i>
                                              Logout
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                    
                                ) : (
                                    <>
                                        <li className="nav-item" id="login_btns">
                                            <button className="nav-link" onClick={handleLoginUrl} id="nav_login">Login</button>
                                            
                                        </li>
                                        <li className="nav-item">
                                            <button className="nav-link" onClick={handleRegisterUrl} id="nav_user">New User</button>

                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}
